import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import css from './ResearchWinesPage.module.css';
import { injectIntl } from '../../util/reactIntl';
import { IoFilter } from 'react-icons/io5';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  IconSpinner,
  Page,
  PaginationLinks,
  Modal,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import SearchForm from '../../components/SearchForm/SearchForm';
import WinesCards from './WinesCards/WinesCards';
import { getListingsById, queryListings } from './ResearchWinesPage.duck';
import FilterByWineType from './WinesFilteration/FilterByWineType';
import FilterByWinePrice from './WinesFilteration/FilterByWinePrice';
import FilterByOtherCriteria from './WinesFilteration/FilterByOtherCriteria';
import FilterByVarietals from './WinesFilteration/FilterByVarietals';
import FilterBySate from './WinesFilteration/FilterByState';
import FilterByRegion from './WinesFilteration/FilterByRegion';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';
import filterIcon from './filter.png';
import StaticPage from '../../containers/StaticPage/StaticPage';
import FilterByWinery from './WinesFilteration/FilterByWinery';
import { getAllWineries, searchWineries } from '../../services/winery';
import { shuffleArray } from '../../util/shuflleArray';
import FilterByShipToState from './WinesFilteration/FilterByShipToState';

const MAX_MOBILE_SCREEN_WIDTH = 768;

// Format value, which should look like { minPrice, maxPrice }
const format = (range) => {
  const { start, end } = range || {};
  // Note: we compare to null, because 0 as start is falsy in comparisons.
  let value;
  if (start === 0) {
    value = `,${parseInt(end * 100)}`;
  } else if (end === 0) {
    value = `${start * 100},`;
  } else {
    value = `${start * 100},${parseInt(end * 100)}`;
  }
  return value;
};

const ResearchWinesPage = ({
  currentUser,
  listings,
  queryParams,
  pagination,
  queryInProgress: winesLoading,
  queryListingsError,
  currentPageResultIds,
  intl,
  states,
  statesLoading,
  statesError,
  varietals,
  varietalsLoading,
  varietalsError,
  viewport,
  onManageDisableScrolling,
  scrollingDisabled,
  onQueryListings,
  allWines
}) => {
  const mountedRef = useRef(true);
  // const wines = listings;
  const [winesToDisplay, setWinesToDisplay] = useState([]);
  const [varietalsToDisplay, setVarietalsToDisplay] = useState([]);
  const [searchValue, setSearchVlaue] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedShipToStates, setSelectedShipToStates] = useState('');
  const [selectedWineTypes, setSelectedWineTypes] = useState('');
  const [selectedPriceRange, setSelectedPriceRange] = useState({ start: 0, end: 0 });
  const [selectedvarietals, setSelectedvarietals] = useState('');
  const [openMobileFilter, setOpenMobileFilter] = useState(false);
  const [wineries, setWineries] = useState([]);
  const [wineriesToShow, setWineriesToShow] = useState([]);
  const [wineryIds, setWineryIds] = useState([]);
  const [wineriesLoading, setWineriesLoading] = useState([]);
  const [selectedWinery, setSelectedWinery] = useState('');
  const [wineryState, setWineryState] = useState([{
    value: "",
    name: ""
  }]);
  const [shipToStates, setShipToStates] = useState([]);

  const hasPaginationInfo = !!pagination && pagination.totalItems != null;
  const winesAreLoaded = !winesLoading && hasPaginationInfo;
  const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;

  useEffect(()=>{
    if (allWines) {
      let tempWineryIds = [];
      allWines.forEach(wine => {
        const wineryId = wine?.attributes?.publicData?.wineryId;
        if (wineryId !== undefined) {
          if (!tempWineryIds.includes(wineryId)) {
            tempWineryIds.push(wineryId);
          }
        }
      });
      setWineryIds(tempWineryIds);
    }
  },[allWines]);

  useEffect(() => {
    if (listings) {
      setWinesToDisplay(listings);
    }
  }, [listings]);

  useEffect(() => setVarietalsToDisplay(varietals), [varietals]);

  useEffect(() => {
    (async () => {
      await searchWineries('', setWineriesLoading, setWineries);
    })();
  }, []);
  
  useEffect(()=>{
    let tempState = [];
    if(wineries.length > 0)
    {
      wineries.forEach((winery)=>{
        if(winery.state !== null && wineryIds.includes(winery._id))
        {
          tempState.push({
            value: winery.state.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); }).trimStart(),
            name: winery.state.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); }).trimStart()
          });
        }
      })
      if(tempState.length > 0)
      {
        setWineryState(Array.from(new Set(tempState.map(JSON.stringify))).map(JSON.parse))
        if (selectedState != "")
        {
          setWineriesToShow(wineries.filter(winery => winery.name !== undefined && winery.name !== null && winery.state ===  selectedState && wineryIds.includes(winery._id)))
        }
        else
        {
          setWineriesToShow(wineries.filter(winery => winery.name !== undefined && winery.name !== null && wineryIds.includes(winery._id)))
        }
      }
    }
  },[wineries])

  useEffect(()=>{
    setSelectedWinery('');
    setSelectedShipToStates('');
    if (selectedState != "")
    {
      setWineriesToShow(wineries.filter(winery => winery.name !== undefined && winery.name !== null && winery.state ===  selectedState && wineryIds.includes(winery._id)));
    }
    else
    {
      setWineriesToShow(wineries.filter(winery => winery.name !== undefined && winery.name !== null &&  wineryIds.includes(winery._id)));
    }
  }, [selectedState])

  useEffect(() => {
    if(wineriesToShow.length > 0 && selectedShipToStates === "")
    {
      let shipToStatesTemp = [];

      wineriesToShow.forEach((winery) => {
        if(winery.shippingStates !== undefined && winery.shippingStates !== null && winery.shippingStates.length > 0)
        {
          winery.shippingStates.forEach((state) => {
            if(state !== undefined && state !== '')
            {
              shipToStatesTemp.push({
                value: state.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); }).trimStart(),
                name: state.replace(/([A-Z])/g, ' $1').replace(/^./, function(str){ return str.toUpperCase(); }).trimStart()
              })
            }
          })
        }
      })  
      if(shipToStatesTemp.length > 0)
      {
        setShipToStates(Array.from(new Set(shipToStatesTemp.map(JSON.stringify))).map(JSON.parse))
      } 
      else
      {
        setShipToStates([{
          value: selectedState,
          name: selectedState
        }]);
      }
    }
  },[wineriesToShow])

  useEffect(() => {
    if(selectedShipToStates !== "")
    {
      if (selectedState != "")
      {
        setWineriesToShow(wineries.filter(winery => winery.name !== undefined && winery.name !== null && winery.state ===  selectedState && wineryIds.includes(winery._id) && winery.shippingStates.includes(selectedShipToStates)));
      }
      else
      {
        setWineriesToShow(wineries.filter(winery => winery.name !== undefined && winery.name !== null && wineryIds.includes(winery._id) && winery.shippingStates.includes(selectedShipToStates)));
      }
    }
  },[selectedShipToStates])

  useEffect(() => {
    let query = {};
    if (selectedState.length > 0) {
      query = { ...query, pub_state: selectedState }
    }
    if (selectedvarietals.length > 0) {
      query = { ...query, pub_varietal: selectedvarietals.toLowerCase() }
    }
    if (selectedWineTypes.length > 0) {
      query = { ...query, pub_type: selectedWineTypes }
    }
    if (selectedPriceRange.start > 0 || selectedPriceRange.end > 0) {
      query = { ...query, price: format(selectedPriceRange) };
    }

    if(selectedShipToStates !== "")
    {
      if (selectedState != "")
      {
        query = { ...query, pub_wineryId: wineries.filter(winery => winery.name !== undefined && winery.name !== null && winery.state ===  selectedState && wineryIds.includes(winery._id) && winery.shippingStates.includes(selectedShipToStates)).map(winery => winery._id) }
      }
      else
      {
        query = { ...query, pub_wineryId: wineries.filter(winery => winery.name !== undefined && winery.name !== null && wineryIds.includes(winery._id) && winery.shippingStates.includes(selectedShipToStates)).map(winery => winery._id) }
      }
    }

    if (selectedWinery.length > 0) {
      query = { ...query, pub_wineryId: selectedWinery }
    }
    onQueryListings(query);
  }, [selectedState,selectedvarietals,selectedWineTypes,selectedPriceRange,selectedWinery,selectedShipToStates]);

  
  const handleSubmit = e => {
    e.preventDefault();
    onQueryListings({ keywords: searchValue });
  };

  const handleMpbileFilterClose = () => {
    setOpenMobileFilter(false);
  };

  const page = queryParams ? queryParams.page : 1;
  const paginationLinks =
    winesAreLoaded && pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="BuyWine"
        pageSearchParams={{ page }}
        pagination={pagination}
      />
    ) : null;

  const renderSearchFilter = () => (
    <div className={css.searchFilterWrapper}>
      <FilterBySate
        states={wineryState}
        selectedState={selectedState}
        setSelectedState={setSelectedState}
      />
      <FilterByShipToState
        states={shipToStates}
        selectedState={selectedShipToStates}
        setSelectedState={setSelectedShipToStates}
      />
      <FilterByWinery
        wineries={wineriesToShow}
        selectedWinery={selectedWinery}
        setSelectedWinery={setSelectedWinery}
      />
      <FilterByWineType
        setSelectedWineTypes={setSelectedWineTypes}
        selectedWineTypes={selectedWineTypes}
      />
      <FilterByWinePrice
        selectedPriceRange={selectedPriceRange}
        setSelectedPriceRange={setSelectedPriceRange}
      />
      <FilterByVarietals
        varietals={varietalsToDisplay}
        setVarietals={setVarietalsToDisplay}
        selectedvarietals={selectedvarietals}
        setSelectedvarietals={setSelectedvarietals}
      />
    </div>
  );

  return (
    <StaticPage
      scrollingDisabled={scrollingDisabled}
      title="Research Wines | Sommly TM"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ResearchWines',
        description: 'Research Wines',
        name: 'ResearchWines',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div className={css.contentWrapper}>
            <div className={css.layoutWrapperHeader}>
              <div className={css.overlay} />
              <div className={css.headerContent}>
                <h1>Buy Wines</h1>
                <div className={css.searchbarContainer}>
                  <SearchForm
                    handleSubmit={handleSubmit}
                    searchValue={searchValue}
                    setSearchVlaue={setSearchVlaue}
                    placeholder="Search"
                  />
                </div>
              </div>
            </div>
            <div className={css.searchContainerWrapper}>
              <div className={css.searchContainer}>
                <div className={css.searchFilterDesktop}>{renderSearchFilter()}</div>
                {/* <div className={css.searchFilterWrapper}>
                  <FilterBySate
                    states={states}
                    statesLoading={statesLoading}
                    selectedState={selectedState}
                    setSelectedState={setSelectedState}
                  />
                  <FilterByWineType
                    setSelectedWineTypes={setSelectedWineTypes}
                    selectedWineTypes={selectedWineTypes}
                  />
                  <FilterByWinePrice
                    selectedPriceRange={selectedPriceRange}
                    setSelectedPriceRange={setSelectedPriceRange}
                  />
                  <FilterByOtherCriteria
                    handleOnChangeLocalfruit={handleOnChangeLocalfruit}
                  />
                  <FilterByVarietals
                    varietals={varietalsToDisplay}
                    setVarietals={setVarietalsToDisplay}
                    selectedvarietals={selectedvarietals}
                    setSelectedvarietals={setSelectedvarietals}
                  />
                </div> */}
                <div className={css.searchResultWrapper}>
                  <div className={css.searchResultTop}>
                    <button className={css.filterBtn} onClick={() => setOpenMobileFilter(true)}>
                      <img src={filterIcon} alt="" />
                      <h2>Filter</h2>
                    </button>
                    <h2>{pagination && pagination.totalItems} Result/s</h2>
                  </div>

                  <div>
                    {winesLoading ? (
                      <div className={css.spinnerWrapper}>
                        <IconSpinner />
                      </div>
                    ) : (
                      <WinesCards winesLoading={winesLoading} wines={winesToDisplay} intl={intl} />
                    )}
                  </div>
                  <div>{paginationLinks}</div>
                </div>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>

      <Modal
        id="WinesMobileFilterSort"
        isOpen={openMobileFilter}
        onClose={handleMpbileFilterClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div style={{ margin: '10px 0 30px' }}>{renderSearchFilter()}</div>
      </Modal>
    </StaticPage>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    currentPageResultIds,
    pagination,
    queryInProgress,
    queryListingsError,
    queryParams,

    states,
    statesLoading,
    statesError,

    varietals,
    varietalsLoading,
    varietalsError,

    allWines
  } = state.ResearchWinesPage;

  const listings = getListingsById(state, currentPageResultIds);

  return {
    currentUser,
    currentPageResultIds,
    listings: shuffleArray(listings),
    // listings: listings,
    queryParams,
    pagination,
    queryInProgress,
    queryListingsError,

    scrollingDisabled: isScrollingDisabled(state),

    states,
    statesLoading,
    statesError,
    varietals,
    varietalsLoading,
    varietalsError,

    allWines
  };
};
const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onQueryListings: page => dispatch(queryListings(page)),
});

export default compose(
  withRouter,
  withViewport,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(ResearchWinesPage);

// export default ResearchWinesPage
